// Action Types
export const SET_CLIENT_PROJECT_DATA = "SET_CLIENT_PROJECT_DATA";
export const RESET_CLIENT_PROJECT = "RESET_CLIENT_PROJECT";

// Action Creators
export const setClientProjectData = (data) => ({
  type: SET_CLIENT_PROJECT_DATA,
  payload: data,
});

export const resetClientProject = () => ({
  type: RESET_CLIENT_PROJECT,
});
